// extracted by mini-css-extract-plugin
export default {"wrapper":"W_FAQBlock_wrapper__N3AmI","header":"W_FAQBlock_header__+QKN-","title":"W_FAQBlock_title__EUQON","items":"W_FAQBlock_items__HaCCr"};